export const liff = {
  error: "",
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getDecodedIDToken: () => {
    return {
      phone_number: "0912345678",
    };
  },
  getProfile: async () => {
    return {
      userId: "Uc3c5c9b97fe978c027bd6f1951082fe8",
      displayName: "Wendy Lin",
      statusMessage: "C'est La Vie 💕",
      pictureUrl:
        "https://profile.line-scdn.net/0hXdWkQRYaB0t6Ei72Xj95NApCBCFZY15ZAnRBLEtGWi5DIBIaUyAbeElCUChAJ0YVUCZLLBwXW352AXAtZET7f30iWXxDJkQeX3VIrg",
    };
  },
  getAccessToken: () =>
    "eyJhbGciOiJIUzI1NiJ9.4rGi6CSzpvwQQtGBRKTJu9gyVSYEVYTiHYVf-_pd-mYIBMaroWRYBgiRyy_IlClGC9bW1qbMOaHPU-M3s1MeJSit6ckqjr8spgYpa3jv6PLWznNwA3hg_TVSjmlUCEiu8kOVP6jsQiPZW-yVdm1pztTF7M4u5x_9y3-eWXqASM4.rveKG-DYHnt7iIGTyOlEeT1AdMBYWEDD2l1cGkxEhtY",
  isLoggedIn: () => true,
  isInClient: () => false,
};
